@for (pregunta of elemento.preguntas; track pregunta.id; let p = $index) {
  <mat-card style="margin: 2vh;" appearance="outlined" [ngClass]="sinResponder(pregunta)" >
    <mat-card-header>
      <mat-card-subtitle>
        <div style="text-align: left; font-size: 12pt;">{{pregunta.order}}. {{pregunta.descripcion}} 
          @if (pregunta.requerida) {
            <span style="color: red; padding-left: 8px; font-size: large;" matTooltip="{{'cues.cuestionarios.requerido'|translate}}">*</span>
          }
        </div>
      </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content style="text-align: left;padding-top: 1vh;">
      <div style="width: 98%;">
        <mat-radio-group [(ngModel)]="preguntas[pregunta.id]" (change)="hojaRespuestas(pregunta.id, $event.value)">
          @for (respuesta of pregunta.respuestas; track respuesta.id; let r = $index) {
            <mat-radio-button   value="{{respuesta.id}}"
            style="margin-right: 3%;">{{respuesta.descrip}}</mat-radio-button>
          }
        </mat-radio-group>
      </div>
      <div style="margin-top: 15px; width: 98%;">
        <label style="display: block; margin-bottom: 8px; font-weight: 500; color: #555; font-size: 11pt;">
          {{'cues.cuestionarios.comentAdi'|translate}} <span style="font-size: 0.85em; color: #999;">({{'cues.cuestionarios.optional'|translate}})</span>
        </label>
        <textarea
          [value]="getComment(pregunta.id)"
          (input)="onCommentChange(pregunta.id, $event)"
          placeholder="Escribe aquí tus comentarios sobre esta respuesta..."
          style="width: 100%; min-height: 80px; padding: 10px; border: 1px solid #ddd; border-radius: 4px; font-family: Arial, sans-serif; font-size: 11pt; resize: vertical;">
        </textarea>
      </div>
    </mat-card-content>
  </mat-card>
}

